import { useCallback } from "react";

import type { ReOnboardingRequestInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { RE_ONBOARDING_REQUEST_MUTATION } from "./schema";

export const useReOnboardingRequestMutation = () => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc } = useCustomMutation(RE_ONBOARDING_REQUEST_MUTATION);

	const onSendReOnboardingRequest = useCallback(
		async (input: ReOnboardingRequestInput) => {
			showLoadingScreenCallback();

			const { errors } = await mutationFunc({ variables: { input } }).finally(() => {
				hideLoadingScreenCallback();
			});

			if (!errors) {
				notifyUserEventInfo({
					variant: "default",
					title: "通知が送信されました",
				});
			}
		},
		[mutationFunc, showLoadingScreenCallback, hideLoadingScreenCallback],
	);

	return {
		onSendReOnboardingRequest,
	};
};
